<template>
    <div class="dropdown">
        <span class="btn dropdown-toggle" role="button" @click.self.stop="toggleDropdown"> </span>
        <div class="dropdown-menu dropdown-menu-right" v-if="showDropdown">
            
            <a :class="[canClickInfo ? '' : 'disabled']" class="dropdown-item" href="#" @click="infoClick">
                <i class="fas fa-info-circle"/> {{resource('JourneyBuilder_JourneyBrickMenu_Info_DisplayName')}}
            </a>
            
            <a :class="[canClickAddConnection ? '' : 'disabled']" class="dropdown-item" href="#" @click="addConnectionClick">
                <i class="fas fa-bullseye"/> {{resource('JourneyBuilder_JourneyBrickMenu_AddRoute_DisplayName')}}
            </a>

            <a :class="[canClickSettings ? '' : 'disabled']" class="dropdown-item" href="#" @click="settingsClick">
                <i class="fas fa-cog"/>{{resource('JourneyBuilder_JourneyBrickMenu_Settings_DisplayName')}}
            </a>

            <a :class="[canClickDelete ? '' : 'disabled']" class="dropdown-item" href="#" @click="deleteClick">
                <i class="fas fa-trash"/>{{resource('JourneyBuilder_JourneyBrickMenu_Remove_DisplayName')}}
            </a>

        </div>
    </div>
</template>

<script>
    /*
        Popper.js attempts to position our dropdown via the CSS transform(...) API
        this does not play well with our zooming framework
        
        since we only use the show/hide feature (no positioning), we should handle the popup ourselves
     */

    import brickTypes from '../../Bricks/brick-types';
    
    import resources from '../../../../Util/Mixins/resources';
    import permissionsMixin from '../../Mixins/journey-permissions';

    export default {
        name: 'journey-brick-menu',
        mixins: [resources, permissionsMixin],
        methods: {
            infoClick(){
                if(this.canClickInfo){
                    this.emitClick('info', arguments);   
                }
            },
            addConnectionClick(){
                if(this.canClickAddConnection){
                    this.emitClick('add-connection', arguments);
                }
            },
            settingsClick(){
                if(this.canClickSettings){
                    this.emitClick('settings', arguments);
                }
            },
            deleteClick(){
                if(this.canClickDelete){
                    this.emitClick('delete', arguments);
                }
            },
            emitClick(type, args){
                this.showDropdown = false;
                this.$emit(`${type}-click`, ...args);
            },
            toggleDropdown(){
                this.showDropdown = !this.showDropdown;
            }
        },
        watch: {
            showDropdown(value){
                const vm = this;
                
                /*
                    We want to close our dropdown when shown, but a click takes place outside of our element
                    thus we attach a global click handler on show
                    as to prevent a memory leak/bogging down; we need to remove it the moment our dropdown is hidden again
                 */
                
                if(value){
                    const handlerRef = () => vm.showDropdown = false;
                    document.addEventListener('click', handlerRef);
                    
                    vm.globalClickHandlerRef = handlerRef;
                }
                else{
                    const handlerRef = vm.globalClickHandlerRef;
                    if(handlerRef){
                        document.removeEventListener('click', handlerRef);
                    }
                }
            }
        },
        data: () => ({
            id: '',
            showDropdown: false,
            
            globalClickHandlerRef: null
        }),
        computed: {
            canClickInfo(){
                return this.isActive;
            },
            canClickAddConnection(){
                //Audience filter connections are added based on brick configuration
                //audience filter bricks should therefor not be able to manually add connections
                if(this.brickType === brickTypes.audienceFilter){
                    return false;
                }
                
               return this.isActive && this.canWrite;
            },
            canClickSettings(){
               return this.canWrite && !this.isChildJourneyBrick;
            },
            canClickDelete(){
                return this.canWrite && !this.isChildJourneyBrick;
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            hasConnections: {
                type: Boolean,
                required: true
            },
            isChildJourneyBrick: {
                type: Boolean,
                required: true
            },
            brickType: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style scoped src="../../Style/journey-brick-menu.scss" lang="scss"/>